// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fundo {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(2px);
}

form {
  background: transparent;
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  width: 4.6rem !important;
  height: 4.6rem !important;
  border-width: 0.55em !important;
  border-right-color: transparent !important;
}

.label {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/Loading/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,wBAAA;EACA,yBAAA;EACA,+BAAA;EACA,0CAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AACF","sourcesContent":[".fundo {\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.3); // transparência escura\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  backdrop-filter: blur(2px); // opcional, para estética\n}\n\nform {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.spinner {\n  width: 4.6rem !important;\n  height: 4.6rem !important;\n  border-width: 0.55em !important;\n  border-right-color: transparent !important;\n}\n\n.label {\n  font-size: 1.2rem;\n  font-weight: bold;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
